import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Calendar from './Calendar';
import { util } from "../../../../../src/shared/util";

class ProfileCalendar extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidUpdate(prevProps) {

  }
 
  render() {
    const { t } = this.props;

    let activities = [];
    const total = this.state.data.length;
    let startDate = null;
    let endDate = null;
    let priorityValue;
    for(let i = 0; i < total; i++){//high, family, non
      startDate = new Date(this.state.data[i].createdAt);
      endDate = null;
      priorityValue = this.state.data[i].status;
      if(this.state.data[i].finishedAt !== null){
        endDate = new Date(this.state.data[i].finishedAt);
      }else{
        endDate = new Date();

        //priorityValue = 'non';
        if(util.getDiffDayHigher(startDate, endDate, 2)){
          //priorityValue = 'high';
        }
      }
      
      activities.push(
        {
          id: this.state.data[i].id,
          title: "Compra de " + this.state.data[i].product.name,
          allDay: true,
          start: startDate,
          end: endDate,
          priority: priorityValue,
        },
      );
    }

    return (
      <Col md={12} lg={12} xl={12}>
        <Card>
          <CardBody className="profile__card--calendar">
            <Calendar events={activities} dir="ltr"  />
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'timeline_form', // a unique identifier for this form
})(withTranslation('common')(ProfileCalendar));
